import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useProfileAdminSwitcherEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.ProfileAdminChannelSwitcher,
    false
  );

  return Boolean(isEnabled);
}
